module.exports = __webpack_public_path__ + "static/media/Tinker.c1b3ab5a.png";